import type { SshKey } from "@warrenio/api-spec/spec.oats.gen";

export const sshKeysExample: SshKey[] = [
    {
        created_at: "2025-10-31 20:45:45",
        name: "Production key",
        public_key:
            "ssh-ed25519 AAAAC3NzaC1lZDI1NTE5AAAAIPqG57t9S5u0jFw8Xn4lCrt3pD4kR7zW8rK0uX2wX1d user@my-local-machine",
        user_id: 136,
        uuid: "7ac48bf1-8d5c-432c-942a-582e275aa25c",
    },
    {
        created_at: "2025-10-31 14:57:09",
        name: "Test key",
        public_key:
            "ssh-ed25519 AAAAC3NzaC1lZDI1NTE5AAAAIPqG57t9S5u0jFw8Xn4lC6y3pD4kR7zW8rK0uX2wX1d user@my-local-machine",
        user_id: 136,
        uuid: "4886cece-d8d0-4308-83cd-0e14b164b238",
    },
];
